const GET_STORAGE_ACCOUNTS_AZURE = 'GET_STORAGE_ACCOUNTS_AZURE';
const GET_STORAGE_ACCOUNTS_AZURE_SUCCESS = 'GET_STORAGE_ACCOUNTS_AZURE_SUCCESS';
const GET_STORAGE_ACCOUNTS_AZURE_ERROR = 'GET_STORAGE_ACCOUNTS_AZURE_ERROR';
 
export {
  GET_STORAGE_ACCOUNTS_AZURE, GET_STORAGE_ACCOUNTS_AZURE_SUCCESS, GET_STORAGE_ACCOUNTS_AZURE_ERROR
  
};
